import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['fr', 'en'],
  defaultLocale: 'fr',
  localePrefix: 'as-needed',
  pathnames: {
    '/': '/',
    '/a-propos': {
      fr: '/a-propos',
      en: '/about',
    },
    '/portfolio': {
      fr: '/experte-communication-realisations',
      en: '/portfolio',
    },
    '/portfolio/[slug]': {
      fr: '/experte-communication-realisations/[slug]',
      en: '/portfolio/[slug]',
    },
    '/blog': {
      fr: '/conseils-communication-blog',
      en: '/blog',
    },
    '/blog/[slug]': {
      fr: '/conseils-communication-blog/[slug]',
      en: '/blog/[slug]',
    },
    '/services': '/services',

    '/services/ugc': {
      fr: '/ugc',
      en: '/services/ugc',
    },
    '/services/gestion-reseaux': {
      fr: '/community-management-freelance',
      en: '/services/gestion-reseaux',
    },
    '/services/coaching': '/services/coaching',
    '/services/creative-strategy': {
      fr: '/creative-strategist-freelance',
      en: '/services/creative-strategy',
    },
    '/contact': '/contact',
    '/mentions-legales': {
      fr: '/mentions-legales',
      en: '/legal-notice',
    },
    '/politique-de-confidentialite': {
      fr: '/politique-de-confidentialite',
      en: '/privacy-policy',
    },
    '/cgv': '/cgv',
    '/landing/[slug]': '/landing/[slug]',
  },
});

export type Pathnames = keyof typeof routing.pathnames;
export type Locale = (typeof routing.locales)[number];
